import { Switch } from 'react-router-dom'
import { CIMSPage, Permission } from 'shared'
import { ProtectedRoute } from 'components/ProtectedRoute'
import SubmittalTracker from './components/SubmittalTracker'
import Subtypes from './components/Subtypes'
import Types from './components/Types'
import RoutingGroups from './components/RoutingGroups'
import CASQuickLinks from './components/CASQuickLinks'
import Notifications from './components/Notifications'
import DispositionTypes from './components/DispositionTypes'

const ConstructionAdminSubmittals: React.FC = () => {
  return (
    <Switch>
      <ProtectedRoute
        path={[CIMSPage.CASTracker.recordPath, CIMSPage.CASTracker.projectPath]}
        permissions={Permission.ViewConstructionAdminSubmittal}
      >
        <SubmittalTracker />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASRoutingGroups.projectPath}
        permissions={Permission.ViewCASRoutingGroup}
      >
        <RoutingGroups />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASTypes.projectPath}
        permissions={Permission.ViewCASType}
      >
        <Types />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASSubtypes.projectPath}
        permissions={Permission.ViewCASSubtype}
      >
        <Subtypes />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASDispositionTypes.projectPath}
        permissions={Permission.ViewCASDispositionType}
      >
        <DispositionTypes />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASQuickLinks.projectPath}
        permissions={Permission.ViewCASQuickLink}
      >
        <CASQuickLinks />
      </ProtectedRoute>
      <ProtectedRoute
        path={CIMSPage.CASNotifications.projectPath}
        permissions={Permission.ViewCASNotification}
      >
        <Notifications />
      </ProtectedRoute>
    </Switch>
  )
}

export default ConstructionAdminSubmittals
